import React from 'react';
import BaseQuiz from '../Base/quiz';
import {InnovativeModuleQuestions} from "./questions";
import image1 from './resources/images/test_1.png'
import image2 from './resources/images/test_2.png'

const InnovativeModuleQuiz = () => {
    return <BaseQuiz
        questions={InnovativeModuleQuestions}
        images={[ image1, image2 ]}
    />
};

export default InnovativeModuleQuiz;
